import { css } from '@emotion/react';

export const seat1a_badge = css`
  border-radius: 100%;
  height: 12px;
  width: 12px;
`;
